import { call } from "@baton/api";
import { keys, type Runtime } from "@baton/core";
import { queryOptions } from "@tanstack/react-query";

/**
 * 011 `contracts/http-api.md` § MCP administration: how many registered clients wait for approval,
 * for the Settings sidebar's badge, which the first page of the pending list carries. The sidebar is
 * in the shell's first load, so this read is a module of its own: taken from `api.ts`, the MCP
 * administration's every read and write came into that load with it (FR-015-120, 2026-10-05).
 */
export function pendingClientsQuery(runtime: Runtime) {
  return queryOptions({
    queryKey: keys.instance.mcpClientsList({ status: "pending", q: "", count: "only" }),
    queryFn: async ({ signal }): Promise<number> => (await call(runtime.signedIn, "get", "/api/v1/instance/mcp/clients", { query: { status: "pending", limit: 1 }, signal })).data.pending_count,
  });
}
